import React from 'react';
import Home from '../Components/Home';

const SignIn = () => {
  return <Home menu='signIn' />;
};

export default SignIn;
